import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SnackbarMessageService {

  subject = new Subject<any>();

  assignDummyGvkey(data: any) {
    this.subject.next({data: data});
  }

  getSnackBarMessage() {
    return this.subject.asObservable();
  }
}
